/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import type { Theme } from '@coursera/cds-core';
import { useTheme } from '@coursera/cds-core';

const styles = {
  itemContentPanelContainer: (theme: Theme) => css`
    background-color: var(--cds-color-white-0);
    position: relative;
    width: 100%;
    height: 100%;
  `,
};

type Props = {
  children?: React.ReactNode;
};

const MiddlePanel: React.FC<Props> = ({ children }) => {
  const theme = useTheme();
  return <div css={styles.itemContentPanelContainer(theme)}>{children}</div>;
};

export default MiddlePanel;
